export function passwordValidator(password) {
  if (!password) return "Kata Sandi tidak boleh kosong."
  if (password.length < 5) return 'Kata sandi harus lebih dari 5 karakter.'
  return ''
}
